// import axios from 'axios'
import axios from '@/utils/request'

export const SPPUCDeviceType = {
  SPPUCDevice_Jly0: 0,
  SPPUCDevice_Tw_Cd: 1,
  SPPUCDevice_Djj: 3,
  SPPUCDevice_Wrj: 4,
  SPPUCDevice_Jc: 5,
  SPPUCDevice_Jly6: 6,
  SPPUCDevice_Jwt7: 7,
  SPPUCDevice_Jwt8: 8,
  SPPUCDevice_Djj_Ls: 9,
  SPPUCDevice_Tw_Ls: 10,
  SPPUCDevice_Tw_Lz: 11,
  SPPUCDevice_Djj_My: 12
}

export const SPPUCDeviceTypeList = [
  // { value: SPPUCDeviceType.SPPUCDevice_Jly0, label: '记录仪（老）' },
  // { value: SPPUCDeviceType.SPPUCDevice_Tw_Cd, label: '成都天网' },
  // { value: SPPUCDeviceType.SPPUCDevice_Djj, label: '省厅对讲机' },
  { value: SPPUCDeviceType.SPPUCDevice_Wrj, label: '无人机' },
  // { value: SPPUCDeviceType.SPPUCDevice_Jc, label: '警车' },
  { value: SPPUCDeviceType.SPPUCDevice_Jly6, label: '执法记录仪' }
  // { value: SPPUCDeviceType.SPPUCDevice_Jwt7, label: '警务通（老）' },
  // { value: SPPUCDeviceType.SPPUCDevice_Jwt8, label: '警务通（新）' },
  // { value: SPPUCDeviceType.SPPUCDevice_Djj_Ls, label: '乐山对讲机' },
  // { value: SPPUCDeviceType.SPPUCDevice_Tw_Ls, label: '乐山天网' },
  // { value: SPPUCDeviceType.SPPUCDevice_Tw_Lz, label: '泸州天网' },
  // { value: SPPUCDeviceType.SPPUCDevice_Djj_My, label: '绵阳对讲机' }
]

// 是否天网设备
export function isTw (type) {
  const list = [
    SPPUCDeviceType.SPPUCDevice_Tw_Cd,
    SPPUCDeviceType.SPPUCDevice_Tw_Ls,
    SPPUCDeviceType.SPPUCDevice_Tw_Lz
  ]
  return list.includes(type)
}

export default class SppucManager {
  userId = ''
  color = ''
  logoutCb = undefined
  deviceChangedCb = undefined
  addDeviceCb = undefined
  removeDeviceCb = undefined
  updateDeviceCb = undefined

  // 融合通信在线设备列表
  deviceOlList = {}

  constructor (userId, color, options) {
    this.userId = userId
    this.color = color
    const _options = options || {}
    this.logoutCb = _options.logoutCb
    this.deviceChangedCb = _options.deviceChangedCb
    this.addDeviceCb = _options.addDeviceCb
    this.removeDeviceCb = _options.removeDeviceCb
    this.updateDeviceCb = _options.updateDeviceCb
    this.init()
  }

  async init () {
    SPPUC.init(this.userId, this.color,
      () => { this.onLogout() },
      (deviceId, state, data) => { this.onPositionChanged(deviceId, state, data) }
    )
    // 位置订阅时间周期设置,单位秒，必须大于3，这个接口好像没效果
    SPPUC.setDyTime(12)
    setTimeout(async () => {
      // const data = await this.getDeviceList(2)
      // console.log('------------', data)
      this.getDevicesOlList()
    }, 1000)
  }

  // 拉取在线设备列表
  async getDevicesOlList () {
    const res1 = await this.getDeviceList(0)
    console.log('------------', res1)
    const orgId = res1[0].org_id
    const deviceList = await this.getDeviceList(orgId)
    console.log('------------', deviceList)
    const { data } = await this.getGxDeviceStatues(deviceList.map(item => item.device_id))
    console.log('------------', data)
    // 放入列表
    const olDevices = data.filter(item => { return item.online === 1 })
    olDevices.forEach(item => {
      this.addDevice(SPPUCDeviceType.SPPUCDevice_Jly6, item.device_id, [104.053687, 30.53981, 0, '6', '执法记录仪'])
    })
  }

  onLogout () {
    if (this.logoutCb) {
      this.logoutCb()
    }
  }

  getDeviceTypeById (deviceId) {
    const types = Object.keys(this.deviceOlList)
    for (let i = 0; i < types.length; i++) {
      const type = types[i]
      const device = this.deviceOlList[type].find(item => {
        return item.deviceId === deviceId
      })
      if (device) {
        return type
      }
    }
    return undefined
  }

  // device_id 设备号
  // state  状态  1位置上报  0设备离线 2设备上线
  // [lng,lat,speed, deviceType, name]  经度，纬度, 速度,设备类型，设备名称
  onPositionChanged (deviceId, state, data) {
    console.log('onPositionChanged=========', deviceId, state, data)
    if (data.length === 0) {
      data = [104.053687, 30.53981, 0, '6', '执法记录仪']
    }
    if (this.deviceChangedCb) {
      this.deviceChangedCb(deviceId, state, data)
    }
    if (state === 0) { // 设备离线
      const deviceType = this.getDeviceTypeById(deviceId)
      if (deviceType === undefined) {
        return
      }
      this.removeDevice(deviceType, deviceId, data)
    } else if (state === 1 || state === 2) { // 设备位置更新
      const deviceType = data[3]
      if (this.deviceOlList[deviceType] && this.deviceOlList[deviceType].findIndex((item) => { return item.deviceId === deviceId }) >= 0) {
        // const oldData = this.deviceOlList[deviceType].find((item) => { return item.deviceId === deviceId })
        // if (Math.abs(oldData.data[0] - data[0]) < 0.000001 && Math.abs(oldData.data[1] - data[1]) < 0.000001) {
        //   return
        // }
        this.updateDevice(deviceType, deviceId, data)
      } else {
        this.addDevice(deviceType, deviceId, data)
      }
    }
  }

  // 移除设备
  removeDevice (deviceType, deviceId, data) {
    if (!this.deviceOlList[deviceType]) {
      return
    }
    const index = this.deviceOlList[deviceType].findIndex((item) => { return item.deviceId === deviceId })
    if (index < 0) {
      return
    }
    this.deviceOlList[deviceType].splice(index, 1)

    if (this.removeDeviceCb) {
      this.removeDeviceCb(deviceType, deviceId, data)
    }
  }

  // 添加设备
  addDevice (deviceType, deviceId, data) {
    const names = data[4] ? data[4].split('_') : ['']
    if (names.length >= 2) {
      data[4] = `${names[0]}-${names[names.length - 1]}`
    }
    if (!this.deviceOlList[deviceType]) {
      this.deviceOlList[deviceType] = []
    }
    if (this.deviceOlList[deviceType].findIndex((item) => { return item.deviceId === deviceId }) >= 0) {
      this.updateDevice(deviceType, deviceId, data)
      return
    } else {
      this.deviceOlList[deviceType].push({
        deviceId: deviceId,
        data: data
      })
    }

    if (this.addDeviceCb) {
      this.addDeviceCb(deviceType, deviceId, data)
    }
  }

  // 更新设备
  updateDevice (deviceType, deviceId, data) {
    if (!this.deviceOlList[deviceType]) {
      this.addDevice(deviceType, deviceId, data)
      return
    }
    const index = this.deviceOlList[deviceType].findIndex((item) => { return item.deviceId === deviceId })
    if (index < 0) {
      this.addDevice(deviceType, deviceId, data)
      return
    }
    // this.deviceOlList[deviceType] = {
    //   deviceId: deviceId,
    //   data: data
    // }
    // 更好融合通信名称
    const names = data[4] ? data[4].split('_') : ['']
    if (names.length >= 2) {
      data[4] = `${names[0]}-${names[names.length - 1]}`
    }
    this.deviceOlList[deviceType][index].data = data

    if (this.updateDeviceCb) {
      this.updateDeviceCb(deviceType, deviceId, data)
    }
  }

  // 获取在线设备列表
  getDevicesOl (deviceType) {
    if (!this.deviceOlList[deviceType]) {
      return []
    }
    return this.deviceOlList[deviceType].map((item) => {
      return {
        id: item.deviceId,
        position: [item.data[0], item.data[1]],
        name: item.data[4] || ''
      }
    })
  }

  // 登录账号退出
  logout () {
    SPPUC.loginOut()
  }

  // 弹出卡片
  // type:设备类型  0记录仪（老）【328开头的账号】  1天网  3 对讲机  4 无人机  5 警车  6记录仪（新）【628开头的账号】 7乐山天网 8泸州天网
  rdCard (id, type, left, top) {
    SPPUC.rdCard(id, type, [left, top])
  }

  // 获取群组列表 同步
  getGroupList () {
    return SPPUC.getGroup()
  }

  // 弹出群组卡片
  groupCard (name, id, left, top) {
    SPPUC.groupCard(name, id, [left, top])
  }

  // 直接视频呼叫
  callVideo (id, type = SPPUCDeviceType.SPPUCDevice_Tw_Cd) {
    console.log('callVideo=====', id, type)
    SPPUC.rdVideo({
      id: id,
      type: type,
      width: '100%',
      height: '100%',
      dom: 'video-player'
    })
  }

  // 挂断关闭视频
  endVideo (id) {
    SPPUC.endVideo(id)
  }

  // 获取群组列表数据 异步（PDT组）
  getJTGroupList () {
    return SPPUC.getJTGroupList()
  }

  // 获取动态群组列表数据
  getDTGroupList () {
    return SPPUC.getDTGroupList()
  }

  // 获取设备历史轨迹数据
  // times:查询时间范围，开始和结束时间差不能超过7天(示例：["2022-10-19 10:00:00","2022-10-20 10:00:00"])
  getPolyList (deviceId, type, times) {
    return SPPUC.getPolyList(deviceId, type, times)
  }

  // 获取设备列表
  getDeviceList (org_id = 0) {
    return SPPUC.getDeviceList(org_id)
  }

  // 1. 查询设备是否在线接口
  getDeviceStatus (deviceId, xt) {
    return axios({
      url: 'https://80.31.103.203:444/rh/Inter/getDeviceStatus',
      method: 'post',
      data: {
        device_id: deviceId,
        xt
      }
    })
  }

  // 打开融合通信设备窗口
  openDeviceWin (id, type) {
    const url = `${process.env.VUE_APP_HTTPS_URL}sppuc.html?id=${id}&type=${type}`
    const features = 'height=500, width=800, top=100, left=100, toolbar=no, menubar=no,scrollbars=no,resizable=no, location=no, status=no'
    window.open(url, 'newW', features)
  }

  /// //////////////////////////////////////////////////////////////高新公安专用接口/////////////////////////////////////////////////////////////////////////
  // 获取高新公安局设备列表
  getGxDeviceList () {
    return axios({
      url: `${process.env.VUE_APP_SPPUC_SERVER}sppuc/rh/Gx/deviceList`,
      method: 'post',
      data: {
        key: process.env.VUE_APP_SPPUC_KEY
      }
    })
  }

  // 获取高新公安局设备状态
  getGxDeviceStatues (ids) {
    return axios({
      url: `${process.env.VUE_APP_SPPUC_SERVER}sppuc/rh/Gx/deviceStatus`,
      method: 'post',
      data: {
        key: process.env.VUE_APP_SPPUC_KEY,
        device_ids: ids || []
      }
    })
  }

  // 获取高新记录仪分组信息
  getJlyGroupList () {
    return axios({
      url: `${process.env.VUE_APP_SPPUC_SERVER}sppuc/rh/Gx/groupList`,
      method: 'post',
      data: {
        key: process.env.VUE_APP_SPPUC_KEY
      }
    })
  }
}
